import { ICustomer } from 'app/modules/customer/model/customer.model';
import { subscriptionApi, subscriptionProcessApi } from '../api';
import { ACTION_TYPES } from './store/subscription-actions';
import { ACTION_TYPES as STEP_ACTION_TYPES } from 'app/modules/journey/service/store/step.actions';
import { getSelectedOffer } from 'app/modules/corporate/service/corporate.service';
import { translate } from 'react-jhipster';
import { updateCustomer } from 'app/modules/customer/service/customer.service';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { isNull } from 'lodash';
import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import history from 'app/history';
import { civilityMap, extractDepartmentFromPostalCode, getCountryNameByValue, getFirstNameString, getSubscriptionToken, isDuplicateSubscriptionError } from 'app/shared/util/method-util';
import { IFirstCustomer } from 'app/modules/firstCustomer/model/firstCustomer.model';
import { AppError } from 'app/shared/util/error-utils';
import { SubscriptionRequest, UpdateSubscriptionRequest } from './store/subscription-state';
import { updateFirstCustomer } from 'app/modules/firstCustomer/service/firstCustomer.service';
import { goSpecificStep } from 'app/modules/journey/service/step.service';

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { v4 as uuidv4 } from 'uuid';

export const getSubscription = (subscriptionNumber: string) => async dispatch => {
  /* API Gateway */
  // const result = await subscriptionApi.getSubscription(subscriptionNumber);

  // Récupérer le token depuis le localStorage
  const token = getSubscriptionToken(subscriptionNumber)

  if (!token) {
    console.error('Token non trouvé pour la souscription:', subscriptionNumber);
    return;
  }

  /* Subscription API V2 */
  const result = await subscriptionProcessApi.getSubscription(subscriptionNumber, token);
  if (result.isFailure) {
    // globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const subscription = result.getValue().response;

  await dispatch({
    type: ACTION_TYPES.SET_SUBSCRIPTION,
    payload: {
      subscriptionNumber: subscription.policyId,
      legalEndDateReflection: new Date(subscription?.effectivePeriod?.endDate),
      offers: subscription.includedCoverages,
      // signTxnCompletedAt: subscription?.creationDate, // TODO delete
      signTxnUrl: subscription.technicalData?.callbackUrlToSign,
      // signTxnId: subscription.signTxnId,
      status: subscription.insuranceAgreementStatus,
      externalRef: subscription?.supplier?.trackingId || ""
    }
  });

  const customerData: Partial<IFirstCustomer> = {
    externalRef: subscription?.supplier?.trackingId || "",
    civility: subscription.partyRoleInAgreements.agreementHolder.personName.prefixTitle?.code === "MR" ? "Monsieur" : "Madame",
    lastName: subscription.partyRoleInAgreements.agreementHolder.personName?.lastName,
    firstName: subscription.partyRoleInAgreements.agreementHolder.personName?.firstName,
    birthday: subscription.partyRoleInAgreements.agreementHolder?.birthDate,
    cityOfBirth: subscription.partyRoleInAgreements.agreementHolder?.birthCity,
    country: subscription.partyRoleInAgreements.agreementHolder.birthCountry?.code,
    address: subscription.partyRoleInAgreements.agreementHolder.postalAddress?.streetLine,
    zipCode: subscription.partyRoleInAgreements.agreementHolder.postalAddress?.postalBoxLine,
    city: subscription.partyRoleInAgreements.agreementHolder.postalAddress?.cityLine,
    phoneNumber: subscription.partyRoleInAgreements.agreementHolder.contactInformation.cellPhones?.[0]?.cellPhone,
    email: subscription.partyRoleInAgreements.agreementHolder.contactInformation.emails?.[0]?.email,
    iban: subscription.partyRoleInAgreements.agreementHolder.bankAccount.unstructuredIban,
    // autres champs !!
  };


  // await dispatch(updateCustomer({ ...subscription.subscriber, confirmEmail: subscription.subscriber.email }));
  await dispatch(updateFirstCustomer(customerData));

  // subscription.includedCoverages[0].commercialOffer.code &&
  //   await dispatch(getSelectedOffer(subscription.includedCoverages[0].commercialOffer.code));
};

export const initializeJourney = (shortOfferCode: string) => async (dispatch, getState) => {
  const { offer } = await getState().config;
  if (offer?.withoutOffer)
    return;
  let result = null;
  if (!shortOfferCode) result = await subscriptionApi.initializeJourney();
  else {
    dispatch({
      type: ACTION_TYPES.SET_SHORT_OFFER_CODE,
      payload: {
        shortOfferCode
      }
    });
    result = await subscriptionApi.initializeJourneyWithShortCode(shortOfferCode);
  }

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const journey = result.getValue();

  await dispatch({
    type: ACTION_TYPES.SET_INITIALIZE_SUBSCRIPTION,
    payload: {
      offers: journey.offers
    }
  });

  await dispatch(getSelectedOffer(journey.offers[0]));
};

export const setFrozenAssetStatus = (status: string) => ({
  type: ACTION_TYPES.SET_FROZEN_ASSET_STATUS,
  payload: status
});

export const getSecureSubscription = (secureToken: string, subscriptionNumber: string) => async dispatch => {
  const result = await subscriptionApi.getSecureSubscription(secureToken, subscriptionNumber);

  if (result.isFailure) {
    const error = result.errorValue();
    if (error.type === 'ForbiddenException') {
      history.push('/too-late');
    } else {
      globalError.next({ type: TYPE_ERROR.GLOBAL, error });
    }
    return;
  }

  const subscription = result.getValue();

  await dispatch({
    type: 'subscription/SET_SUBSCRIPTION',
    payload: {
      subscriptionNumber: subscription.number,
      offers: subscription.offers,
      signTxnCompletedAt: subscription.signTxnCompletedAt,
      status: subscription.status
    }
  });

  await dispatch(updateCustomer({ ...subscription.subscriber, confirmEmail: subscription.subscriber.email }));

  await dispatch(getSelectedOffer(subscription.offers[0]));

  history.replace('/' + subscriptionNumber);
};

export const createPendingSubscription = (customer: ICustomer, subscriptionOffers: string[], reCaptchaValue?: string) => async (
  dispatch,
  getState
) => {
  const { recaptchaActivated, recaptchaSiteKey } = await getState().config;
  const prospection = {
    offers: subscriptionOffers,
    subscriber: {
      ...customer,
      number: null
    }
  };

  dispatch({
    type: ACTION_TYPES.INIT_CREATE_PENDING_SUBSCRIPTION
  });

  let result;
  if (recaptchaActivated && recaptchaSiteKey !== '') {
    result = await subscriptionApi.createPendingSubscriptionWithRecaptcha(prospection, reCaptchaValue);
  } else {
    result = await subscriptionApi.createPendingSubscription(prospection);
  }

  if (result.isFailure) {
    dispatch({
      type: ACTION_TYPES.RESET_CREATE_PENDING_SUBSCRIPTION
    });
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return false;
  }

  const subscription = result.getValue();

  dispatch({
    type: ACTION_TYPES.CREATE_PENDING_SUBSCRIPTION,
    payload: {
      subscriptionNumber: subscription.number
    }
  });

  return true;
};

export const getSubscriptionDocumentsSigned = () => async (dispatch, getState) => {
  const subscription = await getState().subscription;

  if (subscription?.status === 'VALIDATED') {
    const result = await subscriptionApi.getSubscriptionDocumentsSigned(subscription.subscriptionNumber);
    if (result.isSuccess) {
      await dispatch({
        type: ACTION_TYPES.SET_DOCUMENTS_SIGNED,
        payload: result.getValue()
      });
      return;
    }
  }

  await dispatch({
    type: ACTION_TYPES.SET_DOCUMENTS_SIGNED,
    payload: []
  });
};

export const validateSubscriptionAction = () => async (dispatch, getState) => {
  const subscription = await getState().subscription;

  if (!isNull(subscription.signTxnCompletedAt)) {
    await dispatch(gtmEvent('Signature', 'Déjà signé', '0'));
    await dispatch(getSubscriptionDocumentsSigned());
  } else {
    await dispatch(gtmEvent('Signature', 'Erreur signature', 'documentsnotsigned'));
    history.push('/' + subscription.subscriptionNumber + '/failure?error=documentsnotsigned');
  }
};

export const resetSignError = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.RESET_SIGN_ERROR
  });
};

export const setSigningSource = (source: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_SOURCE,
    payload: source
  });
};

export const resetSigningState = () => async dispatch => {
  await dispatch(setSigningSource(null));
  await dispatch(resetSignError());
};

export const requestSigningTransactionUrl = () => async (dispatch, getState) => {
  const { subscriptionNumber } = await getState().subscription;

  await dispatch(resetSignError());

  // Genrere une url
  const result = await subscriptionApi.requestSigningTransactionUrl(subscriptionNumber);

  if (result.isSuccess) {
    await dispatch(setSigningSource(result.getValue()));
    return;
  } else {
    let i = 1;
    let success = false;
    while (i < 11 && !success) {
      // retry 10 fois
      await new Promise(resolve => setTimeout(resolve, 4000));

      // Check if url n'exite pas
      await dispatch(getSubscription(subscriptionNumber));
      const subscription = await getState().subscription;
      if (subscription && subscription.signTxnUrl && subscription.signTxnUrl.length > 0) {
        await dispatch(setSigningSource(subscription.signTxnUrl));
        success = true;
        continue;
      }

      i++;
    }

    if (!success) {
      const errorMessage = translate('form.errors.messages.validateSubscription');
      await dispatch({
        type: ACTION_TYPES.SET_SIGN_ERROR,
        payload: errorMessage
      });
    }
  }
};

// API subscription process


export const validateSubscription = () => async (dispatch, getState) => {
  const { subscriptionNumber } = await getState().subscription;
  await subscriptionProcessApi.validateSubscription(subscriptionNumber);
};

export const requestSigningDocuments = () => async (dispatch, getState) => {
  const { subscriptionNumber } = await getState().subscription;

  await dispatch(resetSignError());

  const token = getSubscriptionToken(subscriptionNumber)

  // Call API
  const result = await subscriptionApi.requestSigningDocuments(subscriptionNumber, token);

  if (result.isSuccess) {
    const response = result.getValue();
    await dispatch(setSigningSource(response));
    return;
  } else {
    // Handle error and retry logic
    let i = 1;
    let success = false;
    while (i < 11 && !success) {

      await new Promise(resolve => setTimeout(resolve, 4000));

      // Check if signing status is available
      await dispatch(getSubscription(subscriptionNumber));
      const subscription = await getState().subscription;

      // You might need to check a different field in the new response structure
      if (subscription && subscription.signingStatus && subscription.signingStatus.url) {
        await dispatch(setSigningSource(subscription.signingStatus.url));
        success = true;
        continue;
      }

      i++;
    }

    if (!success) {
      const errorMessage = translate('form.errors.messages.validateSubscription');
      await dispatch({
        type: ACTION_TYPES.SET_SIGN_ERROR,
        payload: errorMessage
      });
    }
  }
};

export const createPendingSubscriptionProcess = (
  customer: IFirstCustomer,
  offer: string,
  reCaptchaValue?: string
) => async (dispatch, getState) => {
  const { recaptchaActivated, recaptchaSiteKey } = await getState().config;

  // Construire le subscriptionRequest
  const subscriptionRequest: SubscriptionRequest = {
    request: {
      subscriptionChannel: "STORE",
      supplier: {
        trackingId: customer?.externalRef || "",
      },
      agreementHolder: {
        agreementHolderType: "PersonRef",
        contactInformation: {
          emails: [{ email: customer?.email }],
          cellPhones: [{ cellPhone: customer?.phoneNumber }],
          landlineNumbers: [{ landlineNumber: customer?.phone || '' }],
          faxNumbers: [{ faxNumber: '' }]
        },
        personName: {
          prefixTitle: { code: civilityMap[customer.civility] || "MR" },
          firstName: getFirstNameString(customer.firstName),
          lastName: customer?.lastName
        },
        birthDate: customer?.birthday, // Format: "1991-01-27"
        genderCode: customer.gender === "F" ? "FEMALE" : "MALE"
      },
      includedCoverages: [
        {
          commercialOffer: {
            code: offer
          }
        }
      ]
    },
    reCaptchaValue
  };

  dispatch({ type: ACTION_TYPES.INIT_CREATE_PENDING_SUBSCRIPTION });

  const result = await subscriptionProcessApi.createSubscription(subscriptionRequest);

  if (result.isFailure) {
    const error = result.errorValue() as unknown as any;

    // Gestion spécifique du cas "déjà souscrit" basée sur la réponse API
    if (isDuplicateSubscriptionError(error)) {
        await dispatch(gtmEvent('Adhésion', 'Doublon', '0'));
      dispatch({
        type: ACTION_TYPES.SET_SUBSCRIPTION_DUPLICATE,
        payload: 'DUPLICATE'
      });
      return false;
    }
    dispatch({ type: ACTION_TYPES.RESET_CREATE_PENDING_SUBSCRIPTION });
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() as unknown as AppError });
    return false;
  }

  const subscription = result.getValue();

  dispatch({
    type: ACTION_TYPES.CREATE_PENDING_SUBSCRIPTION,
    payload: {
      subscriptionNumber: subscription.response.subscriptionId
    }
  });

  if (subscription.token && subscription.response.subscriptionId) {
    localStorage.setItem(`subscriptionToken_${subscription.response.subscriptionId}`, subscription.token);
  }

  return true;
};


export const updateCustomerSubscription = (
  subscriptionId: string,
  customer: IFirstCustomer
) => async (dispatch) => {
  // Récupérer le token depuis le localStorage
  const token = getSubscriptionToken(subscriptionId)

  if (!token) {
    console.error('Token non trouvé pour la souscription:', subscriptionId);
    const appError = new AppError({
      message: 'Session invalide. Veuillez rafraîchir la page.',
      type: 'AUTH_ERROR',
      details: []
    });
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: appError });
    return false;
  }

  const updateRequest: Partial<UpdateSubscriptionRequest> = {
    request: {
      subscriptionChannel: "STORE",
      supplier: {
        trackingId: customer?.externalRef || ""
      },
      partyRoleInAgreements: {
        agreementHolder: {
          agreementHolderType: "Person",
          personName: {
            firstName: getFirstNameString(customer?.firstName),
            lastName: customer?.lastName,
            prefixTitle: { code: civilityMap[customer?.civility] || "MR" }
          },
          birthCity: customer?.cityOfBirth || '',
          birthCountry: customer.isoTwoCountryOfBirth
            ? {
              code: customer.isoTwoCountryOfBirth,
              label: getCountryNameByValue(customer.isoTwoCountryOfBirth) || ''
            }
            : { code: '', label: '' },
          birthDate: customer?.birthday || '',
          birthDepartment: extractDepartmentFromPostalCode(customer?.zipCode) || 99,
          birthName: customer?.lastNameOfBirth || '',
          genderCode: civilityMap[customer?.civility] === "MRS" ? "FEMALE" : "MALE",
          isThePrincipalInsured: true,
          bankAccount: {
            accountHolderName: customer?.accountHolder || '',
            unstructuredIban: customer?.iban || ''
          },
          customerRef: {},
          contactInformation: {
            emails: [{ email: customer?.email || '' }],
            cellPhones: [{ cellPhone: customer?.phoneNumber || '' }],
            landlineNumbers: [{ landlineNumber: '' }],
            faxNumbers: [{ faxNumber: '' }]
          },
          postalAddress: {
            buildingLine: '',
            cityLine: customer?.city || '',
            countryLine: {
              code: customer?.country || '',
              label: getCountryNameByValue(customer?.country) || ''
            },
            localityLine: '',
            postalBoxLine: customer?.zipCode || '',
            recipientComplementLine: '',
            recipientNameLine: `${customer?.civility || ''} ${customer?.firstName || ''} ${customer?.lastName || ''}`.trim(),
            streetLine: customer?.address || ''
          }
        }
      }
    }
  };



  const result = await subscriptionProcessApi.updateSubscription(subscriptionId, updateRequest, token);

  if (result.isFailure) {
    const rawError = result.errorValue();

    const appError = new AppError({
      message: 'Erreur lors de la mise à jour de l’adhésion.',
      type: 'API_ERROR',
      details: typeof rawError === 'string' ? [rawError] : []
    });

    globalError.next({ type: TYPE_ERROR.GLOBAL, error: appError });
    return false;
  }

  const frozenAssetStatus = result?.getValue()?.response?.partyRoleInAgreements?.agreementHolder?.frozenAssetStatus;
  dispatch(setFrozenAssetStatus(frozenAssetStatus));

  if (frozenAssetStatus !== "UNFROZEN" && frozenAssetStatus !== "UNVERIFIED") {
    dispatch(goSpecificStep(dispatch, STEP_ACTION_TYPES.UPDATE_STEP, 5, null));
    return false;
  }
  return true;
};


export const useSubscriptionToken = () => {
  const [token, setToken] = useState<string>('');
  const subscriptionNumber = useSelector((state: IRootState) => state.subscription.subscriptionNumber);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');

    if (urlToken) {
      setToken(urlToken);
      localStorage.setItem(`subscriptionToken_${subscriptionNumber}`, urlToken);
    } else if (subscriptionNumber) {

      const storedToken = localStorage.getItem(`subscriptionToken_${subscriptionNumber}`);
      if (storedToken) {
        setToken(storedToken);
      }
    }
  }, [subscriptionNumber]);

  const getSecureUrl = (url: string): string => {
    if (!token) return url;
    return url.includes('?') ? `${url}&token=${token}` : `${url}?token=${token}`;
  };

  return { token, getSecureUrl };
};
